import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/lib/translations";

const I18nContext = createContext(null);
const KEY = "acos.lang";

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem(KEY);
    if (stored === "fr" || stored === "en") return stored;
    const nav = navigator.language?.slice(0, 2);
    return nav === "en" ? "en" : "fr";
  });

  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l), []);
  const t = useCallback(
    (path) => {
      const dict = translations[lang] || translations.fr;
      const value = path.split(".").reduce((acc, k) => (acc && acc[k] != null ? acc[k] : null), dict);
      if (value == null) return path;
      return value;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
